import useUserCountry from 'hooks/common/use-user-country';
import { useConfig } from 'config/use-config';

export const useMinSubscriptionValue = (): number => {
  const { minimumSubscriptionValue, minimumSubscriptionValueAT } = useConfig();
  const { isAustria } = useUserCountry();

  return isAustria && minimumSubscriptionValueAT !== undefined
    ? minimumSubscriptionValueAT
    : minimumSubscriptionValue;
};
